/* eslint-disable no-unused-vars */
import PersistenceError from 'platform/adapter/persistence/error'
import persistence from 'platform/adapter/persistence/helper/persistence'

/**
 * @memberOf Gaia.Adapter.Persistence.PersistenceAPI
 * @typedef {PersistenceAPI} DisabledAPI
 * @returns {DisabledAPI}
 */
export default (() => Object.create(persistence, {
  get: {
    /**
     * Attempts to obtain a persisted {@link Draft} from the database.
     *
     * @param {string} id the identifier of the {@link Draft} to obtain
     * @returns {Promise<Draft>} the obtained {@link Draft}
     */
    value: async (id) => {
      throw new PersistenceError('Persistence is disabled')
    },
    iterable: true,
    enumerable: true,
  },
  getAll: {
    /**
     * Attempts to obtain the list of persisted {@link Draft} entities that fulfills `condition`
     * from the database.
     *
     * @param {Object} condition an object defining a property with a value both of which the
     *                           returned items must have (e.g. `{ type: 'person' }`)
     * @returns {Promise<Draft>} the obtained {@link Draft}
     */
    value: async (condition) => {
      throw new PersistenceError('Persistence is disabled')
    },
    iterable: true,
    enumerable: true,
  },
}))()
